import DefaultLayout, {
  OverlayLoader,
} from "./Layout/DefaultLayout/DefaultLayout";
// import { Router, Route } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import Login from "./Components/Login/Login";
import DefaultHeader from "./Layout/DefaultHeader/DefaultHeader";
import DefaultFooter from "./Layout/DefaultFooter/DefaultFooter";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import ValidationForm from "./Components/ValidationForm/ValidationForm";
import Dashboard from "./Components/Dashboard/Dashboard";
import "react-toastify/dist/ReactToastify.css";
import TContainer from "./Utils/errorMsg/ToastContainer";
import { useDispatch, useSelector } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { ProgressBar } from "react-bootstrap";
import Home from "./Pages/YH/Home";
import Configuration from "./Pages/YH/Configuraion";
import VUser from "./Components/User/VUser";
import LogList from "./Components/LogList/LogList";
import ServerInfo from "./Components/ServerInfo/ServerInfo";
import JobList from "./Components/JobList/JobList";
import AppConfig from "./Components/License/AppConfig";
import { uiLogout } from "./Utils/actions/auth";
import ApplicationCnfig from "./Components/License/AppConfig/ApplicationCnfig";
import ManageDetails from "./Components/User/ManageInfo/ManageDetails";
import Reports from "./Components/Reports/Reports";
import Template from "./Components/Dashboard/Template";
import SyncService from "./Components/SyncService/SyncService";

const App = () => {
  const location = useLocation();
  const { loading, progressLoading, uploadProgress } = useSelector(
    (state) => state.data
  );
  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";
  const dispatch = useDispatch();
  const [activeButton, setActiveButton] = useState(location.pathname.slice(1));
  const [userIsActive, setUserIsActive] = useState(true);
  // Define paths where header/footer should NOT be shown
  const pathsWithoutHeaderFooter = ["/login", "/validForm", "/veras/#/login"]; // Ensure /login is included

  useEffect(() => {
    let activityTimer;

    const handleUserActivity = () => {
      setUserIsActive(true);

      // Reset the timer when user activity occurs
      clearTimeout(activityTimer);

      // Set a new timer for inactivity
      activityTimer = setTimeout(() => {
        setUserIsActive(false);
      }, 600000); // Adjust the time threshold as needed (e.g., 600000 milliseconds = 10 minutes)
    };

    // Add event listeners for user activity
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    // Cleanup: remove event listeners on component unmount
    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);

      // Clear the timer on unmount
      clearTimeout(activityTimer);
    };
  }, []);

  useEffect(() => {
    if (!userIsActive) {
      dispatch(uiLogout());
    }
  }, [userIsActive]);

  useEffect(() => {
    let pathname = location.pathname.slice(1);
    if (pathname === "appConfig") {
      pathname = "configForm";
    }
    setActiveButton(pathname);
  }, [location.pathname]);

  const shouldShowHeaderFooter = !pathsWithoutHeaderFooter.includes(
    location.pathname
  );

  return (
    <Fragment>
      {loading && location.pathname !== "/login" && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            // backgroundColor: "#313131a6",
            backgroundColor: "rgba(0, 0, 0, 0.45)",

            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <OverlayLoader />
        </div>
      )}
      <div>
        {/* <LoadingOverlay
          active={loading}
          spinner={<OverlayLoader />}
          styles={{
            content: {
              display: "flex",
              width: "100vw",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
        > */}
        <div>
          {shouldShowHeaderFooter ? (
            <DefaultHeader
              activeButton={activeButton}
              setActiveButton={setActiveButton}
            />
          ) : (
            <></>
          )}
        </div>
        <div className="AppBox">
          {/* <LoadingOverlay
              active={progressLoading}
              spinner={
                <ProgressBar
                  striped
                  animated
                  variant="primary"
                  now={uploadProgress}
                  label={`${uploadProgress} %`}
                  styles={{ content: { width: "50vw" } }}
                />
              }
            > */}
          {progressLoading && (
            <div
              style={{
                width: "50vw",
                margin: "0 auto",
                padding: "1rem 0",
              }}
            >
              <ProgressBar
                striped
                animated
                variant="primary"
                now={uploadProgress}
                label={`${uploadProgress} %`}
              />
            </div>
          )}
          <Routes>
            <Route name="Login" path={"/login"} element={<Login />} />
            <Route path={"/"} name="home" element={<DefaultLayout />} />
            <Route
              path={"/validForm"}
              name="validForm"
              element={<ValidationForm />}
            />
            {cmpntGroup["jobs"]?.Read && (
              <Route path={"/dashboard"} exact element={<Dashboard />} />
            )}
            <Route path="/manage" element={<ManageDetails />} />
            {cmpntGroup["dq"]?.Read && <Route path="/dq" element={<Home />} />}
            {cmpntGroup["dq"]?.Read && (
              <Route path="/configuration" element={<Configuration />} />
            )}
            {/* <Redirect from="*" to="/not-found" /> */}

            {/* <Route path={"/licenseLogin"} name="licenseManage" component={LicenseManage} /> */}

            {/* <Route name='appConfig' path={"/appConfig"} render={(props) => <AppConfig {...props} />}/> */}
            {/* {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? cmpntGroup["user"]?.Read && cmpntGroup["appProperties"]?.Read ? <Route path={"/user"} name="users" element={<VUser />} /> : cmpntGroup["user"]?.Read || cmpntGroup["appProperties"]?.Read ?  <Route path={"/user"} name="users" element={<VUser />} /> : null : <Route path={"/user"} name="users" element={<VUser />} /> } */}
            {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
              cmpntGroup["user"]?.Read &&
              cmpntGroup["appProperties"]?.Read &&
              cmpntGroup["audit"]?.Read ? (
                <Route path={"/user"} name="users" element={<VUser />} />
              ) : cmpntGroup["user"]?.Read ||
                cmpntGroup["appProperties"]?.Read ||
                cmpntGroup["audit"]?.Read ? (
                <Route path={"/user"} name="users" element={<VUser />} />
              ) : null
            ) : (
              <Route path={"/user"} name="users" element={<VUser />} />
            )}
            {cmpntGroup["logs"]?.Read && (
              <Route path={"/logs"} name="logs" element={<LogList />} />
            )}
            {/* <Route path={"/userRoles"} name="userRoles" component={VUserRole} /> */}
            {cmpntGroup["serverInfo"]?.Read && (
              <Route
                path={"/serverInfo"}
                name="serverInfo"
                element={<ServerInfo />}
              />
            )}
            {cmpntGroup["jobs"]?.Read && (
              <Route path={"/jobs"} name="jobs" element={<JobList />} />
            )}
            {cmpntGroup["reports"]?.Read && (
              <Route path={"/reports"} name="reports" element={<Reports />} />
            )}
            {cmpntGroup["syncService"]?.Read && (
              <Route
                path={"/syncService"}
                name="syncService"
                element={<SyncService />}
              />
            )}
            {
              <Route
                path={"/configForm"}
                name="configForm"
                element={<AppConfig />}
              />
            }
            {
              <Route
                path={"/template"}
                name="template"
                element={<Template />}
              />
            }
            {cmpntGroup["configuration"]?.Read &&
            cmpntGroup["dataProvider"]?.Read &&
            cmpntGroup["teamNotification"]?.Read &&
            cmpntGroup["nodeInfo"]?.Read ? (
              <Route
                name="appConfig"
                path="/appConfig"
                element={<ApplicationCnfig />}
              />
            ) : cmpntGroup["configuration"]?.Read ||
              cmpntGroup["dataProvider"]?.Read ||
              cmpntGroup["teamNotification"]?.Read ||
              cmpntGroup["nodeInfo"]?.Read ? (
              <Route
                name="appConfig"
                path="/appConfig"
                element={<ApplicationCnfig />}
              />
            ) : null}
          </Routes>
          {/* </LoadingOverlay> */}
        </div>
        <TContainer />
        <div className="col-md-12">
          {shouldShowHeaderFooter ? <DefaultFooter /> : <></>}{" "}
        </div>
        {/* </LoadingOverlay> */}
      </div>
    </Fragment>
  );
};

export default App;
